import { formatAmount } from './units.js';

const DENOMINATORS = [2, 3, 4, 8];

/** 0.75 -> "3/4", 1.5 -> "1 1/2", 2 -> "2". Falls back to decimals if no clean fraction fits. */
export function formatFraction(n: number): string {
  const whole = Math.floor(n + 1e-9);
  const frac = n - whole;
  if (frac < 0.01) return String(whole);
  for (const d of DENOMINATORS) {
    const num = Math.round(frac * d);
    if (num > 0 && num < d && Math.abs(frac - num / d) < 0.01) {
      return whole > 0 ? `${whole} ${num}/${d}` : `${num}/${d}`;
    }
  }
  return formatAmount(n);
}

/** "2 : 3/4 : 3/4": the amounts themselves, in the order given (unit left to the caller). */
export function amountsRatio(amounts: number[]): string {
  return amounts.map(formatFraction).join(' : ');
}

/**
 * Smallest whole-number parts: [2, 0.75, 0.75] -> "8 : 3 : 3".
 * Falls back to "x : 1 : 1" style decimals (smallest = 1) if no small whole ratio fits.
 */
export function partsRatio(amounts: number[]): string {
  const positive = amounts.filter((a) => a > 0);
  if (positive.length === 0) return '';
  const min = Math.min(...positive);
  const rel = amounts.map((a) => a / min);
  for (let k = 1; k <= 8; k++) {
    if (rel.every((r) => Math.abs(r * k - Math.round(r * k)) < 0.03)) {
      return rel.map((r) => String(Math.round(r * k))).join(' : ');
    }
  }
  return rel.map((r) => formatAmount(r)).join(' : ');
}
